import {
  Button, DatePicker, Flex, Form
} from "antd";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import useBlockedPeriod from "./useBlockedPeriod";
import classes from "./blockedPeriod.module.css";

const { RangePicker } = DatePicker;

const BlockedPeriod = () => {
  const { t } = useTranslation();
  const {
    form,
    loading,
    onRemove,
    deleteLoading,
    onSubmit,
    currentPeriod,
    blockedPeriods,
    setCurrentPeriod
  } = useBlockedPeriod();

  return (
    <Flex vertical gap={16}>
      <Form
        form={form}
        onFinish={onSubmit}
      >
        <Flex gap={8}>
          <Form.Item
            name="period"
            style={{ marginBottom: 0, flexGrow: 1 }}
          >
            <RangePicker
              onChange={(value) => setCurrentPeriod(value)}
              placeholder={[
                t("availabilityPage.blockedPeriod.placeholderFrom"),
                t("availabilityPage.blockedPeriod.placeholderTo")
              ]}
              format="DD/MM/YYYY"
              size="large"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Button
            type="text"
            icon={<PlusCircleOutlined />}
            size="large"
            htmlType="submit"
            disabled={!currentPeriod}
            loading={loading}
          />
        </Flex>
      </Form>
      <Flex vertical gap={8}>
        {blockedPeriods ? blockedPeriods.map((period) => (
          <Flex gap={8} key={period.id}>
            <RangePicker
              value={[dayjs(period.from), dayjs(period.to)]}
              format="DD/MM/YYYY"
              allowClear={false}
              placeholder={[
                t("availabilityPage.blockedPeriod.placeholderFrom"),
                t("availabilityPage.blockedPeriod.placeholderTo")
              ]}
              inputReadOnly
              open={false}
              disabled
              size="large"
              variant="borderless"
              className={classes.time}
            />
            <Button
              type="text"
              icon={<MinusCircleOutlined />}
              size="large"
              htmlType="submit"
              onClick={() => onRemove(period.id)}
              disabled={loading || deleteLoading}
              loading={loading || deleteLoading}
              style={{ flexShrink: 0 }}
            />
          </Flex>
        )) : null}
      </Flex>
    </Flex>
  );
};

export default BlockedPeriod;
